import { State } from "../EntityStores/StateStore";
import { IUser } from '../../components/Auth';

type IUserNullable = IUser | null
/**
 * GoogleAnalyticsStore
 *
 * @author nicolacastellani@vas.it
 * @description this is a substore to handle google analytics
 */
export class GoogleAnalyticsStore {

  async registerEvent(location: string, user: IUserNullable, detail?: boolean) {
    if (user && user.id) {
      await fetch(`${window.BACKEND_ENDPOINT}/saveEvent`, {
        method: 'PUT',
        body: JSON.stringify({ location: `${detail ? 'detail/' : ''}${location}`, userID: user.id, name: user.displayName }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(response => response.json())
        .then(data => console.log(data))
        .catch()
    } else {
      console.error('GA: User unsetted, cannot register event')
    }
  }

  public async onCountryNavigation(selectedState: State, user: IUserNullable) {
    //console.log("[GA] Should track state details event");
    await this.registerEvent(selectedState.name, user);
  }


  public async onDetailsNavigation(selectedState: State, user: IUserNullable) {
    //console.log("[GA] Should track state details event");
    await this.registerEvent(selectedState.name, user, true);
  }


  public async onHomeNavigation(user: IUserNullable) {
    console.log("[GA] Should track home navigation event");

    await this.registerEvent('HOME', user);
  }
}
